import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
    fonts: {
        body: "rb-freigeist-neue, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
        heading: "rb-freigeist-neue, ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
        mono: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
    },
 
    components: {

    MenuItem: {
        baseStyle: {
            item: {
            fontFamily: "rb-freigeist-neue, ui-sans-serif, system-ui, sans-serif",
            fontWeight: "bold",  // Match the fontWeight of the MenuButton
            },
        },
        },
      
    Input: {
      baseStyle: {
        field: {
          _focus: {
            borderColor: "black",
            boxShadow: "0 0 0 1px black",
          },
        },
      },
    },
    Heading: {
        baseStyle: {
          fontFamily: "rb-freigeist-neue, ui-sans-serif, system-ui, sans-serif",
        },
      },
      Text: {
        baseStyle: {
          fontFamily: "rb-freigeist-neue, ui-sans-serif, system-ui, sans-serif",
        },
      },
  
  },
});

export default theme;